import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "../../../Company/Pages/Notification/Notification.css";
import { MdDelete } from "react-icons/md";
import multipleMarkedIcon from "../../../assets/multiple-marked.png";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { Oval } from "react-loader-spinner";
import axios from "axios";
import { errorPopup, successPopup } from "../../../Utils/ToasterMessage";
import { URLS } from "../../../Utils/App_urls";
export default function UserNotification() {
  const [filterBtn, setFilterBtn] = useState({
    all: true,
    newApplication: false,
    jobUpdates: false,
    accountUpdates: false,
  });

  const [allNotifications, setAllNotifications] = useState(null);
  const [totalPage, setTotalPage] = useState(0);
  const [loader, setLoader] = useState(false);
  const [notificationRange, setNotificationRange] = useState({
    page: 1,
    limit: 100,
    status: true,
  });

  const handleFilterBtnChange = (type) => {
    type === "all" &&
      setFilterBtn({
        all: true,
        newApplication: false,
        jobUpdates: false,
        accountUpdates: false,
      });
    type === "newApplication" &&
      setFilterBtn({
        all: false,
        newApplication: true,
        jobUpdates: false,
        accountUpdates: false,
      });
    type === "jobUpdates" &&
      setFilterBtn({
        all: false,
        newApplication: false,
        jobUpdates: true,
        accountUpdates: false,
      });
    type === "accountUpdates" &&
      setFilterBtn({
        all: false,
        newApplication: false,
        jobUpdates: false,
        accountUpdates: true,
      });
  };

  const handleFilterType = (type = "") => {
    console.log(type);
  };

  const markAllAsRead = () => {
    setLoader(true);
    axios
      .patch(
        `${URLS?.readAllNotificationsUser}`,
        { status: "read" },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      )
      .then((res) => {
        getAllNotification();
        return res;
      })
      .catch((err) => console.error(err))
      .finally(() => setLoader(false));
  };

  const deleteNotificationById = (id) => {
    axios
      .delete(`${URLS.deleteNotificationByIdUser}`, {
        params: {
          Id: id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      })
      .then((res) => {
        console.log("======", res);
        toast.success("Deleted");
        getAllNotification(10, 1);
      })
      .catch((err) => {
        errorPopup(err?.response?.data?.message);
      });
  };
  console.log("token", localStorage.getItem("userToken"));

  const getAllNotification = async (limit = null, page = null) => {
    try {
      const response = await axios.get(`${URLS.getNotificationUser}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
        params: {
          limit,
          page,
        },
      });
      console.log(response.data);
      setAllNotifications(response?.data?.data);
      setTotalPage(response?.data?.data?.notification?.totalResults);
      return response?.data?.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const deleteAllNotification = () => {
    axios
      .delete(`${URLS.deleteAllNotificationUser}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      })
      .then((res) => {
        successPopup(res?.data?.message);
        getAllNotification();
      })
      .catch((err) => {
        errorPopup(err?.response?.data?.message);
      });
  };

  const handleFormateDate = (dateStr = "2024-12-17T05:08:32.055Z") => {
    let date = new Date(dateStr);
    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
    const timeFormated = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return `${formattedDate} | ${timeFormated}`;
  };

  useEffect(() => {
    getAllNotification();
    console.log(
      `delete all notification api url is ${URLS.deleteAllNotificationUser}`
    );
  }, []);
  return (
    <>
      <div className="w-100">
        <h1 className="notication_title">Notification</h1>
        <div className="notification-main">
          <div className="d-flex justify-content-between align-items-center gap-2 flex-wrap">
            <div className="d-none d-lg-block">
              <div className="notification-filterbtns d-flex gap-1 flex-md-row flex-column flex-wrap justify-content-between">
                <div
                  onClick={() => handleFilterBtnChange("all")}
                  className={`${filterBtn.all && "active-notifi-filterBtn"}`}
                >
                  All
                </div>
                <div
                  onClick={() => handleFilterBtnChange("newApplication")}
                  className={`${
                    filterBtn.newApplication && "active-notifi-filterBtn"
                  }`}
                >
                  New Application
                </div>
                <div
                  onClick={() => handleFilterBtnChange("jobUpdates")}
                  className={`${
                    filterBtn.jobUpdates && "active-notifi-filterBtn"
                  }`}
                >
                  Job Updates
                </div>
                <div
                  onClick={() => handleFilterBtnChange("accountUpdates")}
                  className={`${
                    filterBtn.accountUpdates && "active-notifi-filterBtn"
                  }`}
                >
                  Account Updates
                </div>
              </div>
            </div>
            {/* <DropdownButton
            id="dropdown-basic-button"
            className="d-block d-lg-none responsiveMenu mb-2"
            title="Dropdown button"
          >
            <Dropdown.Item onClick={() => handleFilterType("all")}>
              All
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handleFilterType("new application")}>
              New Application
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handleFilterType("Job Updated")}>
              Job Updates
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handleFilterType("Account Updates")}>
              Account Updates
            </Dropdown.Item>
          </DropdownButton> */}
            <div className="notification_action_btns d-flex justify-content-between flex-wrap gap-2 gap-sm-4">
              <button onClick={() => markAllAsRead()}>
                {loader ? (
                  <span
                    style={{
                      width: "20px",
                      display: "inline-block",
                      marginRight: "5px",
                    }}
                  >
                    <Oval width={20} height={18} />
                  </span>
                ) : (
                  <img src={multipleMarkedIcon} alt="multipleMarkedIcon" />
                )}
                Marked All as Read
              </button>
              <button onClick={deleteAllNotification}>
                <MdDelete fontSize={24} /> Remove All
              </button>
            </div>
          </div>
          <div className="notification_items_list mt-4">
            {allNotifications?.notifications?.results?.map((notifi, idx) => (
              <div
                key={idx}
                className={`d-flex justify-content-between align-items-center gap-2 mb-2 ${
                  notifi?.status === "unread" ? "unread_bgc" : ""
                }`}
              >
                <div className="notication-list mb-3">
                  <p>{notifi.notificationTitle}</p>
                  <p>{notifi?.notificationBody}</p>
                  <p>{handleFormateDate(notifi?.createdAt)}</p>
                </div>
                <div
                  onClick={() => {
                    console.log("Notification ID to delete:", notifi?._id);
                    deleteNotificationById(notifi?._id);
                  }}
                  className="delete_wrapper"
                >
                  <MdDelete fontSize={24} />
                </div>
              </div>
            ))}
          </div>

          <div className="view_option d-flex flex-column align-items-center">
            {totalPage > notificationRange?.limit ? (
              <span
                onClick={() => {
                  getAllNotification(notificationRange?.limit + 50, 1);
                  setNotificationRange((prev) => ({
                    ...prev,
                    limit: prev.limit + 50,
                    status: false,
                  }));
                }}
              >
                View more...
              </span>
            ) : (
              <>
                {notificationRange?.limit > 100 && (
                  <span
                    onClick={() => {
                      getAllNotification(100, 1);
                      setNotificationRange((prev) => ({
                        ...prev,
                        status: true,
                      }));
                    }}
                  >
                    Show Less
                  </span>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
